import React from 'react';
import { ArrowRight, Users } from 'lucide-react';
import { specialtyVisual } from './specialtyMeta';
import { IITH, SERIF, SANS } from './iithBrand';

export default function SpecialtyBrowse({ groups, primary, onSelectSpecialty }) {
  const accent = primary || IITH.saffron;

  if (!groups.length) {
    return (
      <section id="specialties" className="py-20" style={{ background: IITH.ink }}>
        <div className="max-w-6xl mx-auto px-5 text-center text-[#9AADBE] text-sm">
          Specialties will appear once doctors are published.
        </div>
      </section>
    );
  }

  return (
    <section id="specialties" className="py-20 sm:py-24" style={{ background: IITH.navy }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <div className="max-w-2xl mb-10">
          <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.gold }}>Clinical services</p>
          <h2 className="text-3xl sm:text-4xl font-bold mt-2 tracking-tight text-white" style={{ fontFamily: SERIF }}>
            Book a <span style={{ color: accent }}>General Physician</span>
          </h2>
          <p className="text-sm mt-3 leading-relaxed" style={{ color: IITH.mute, fontFamily: SANS }}>
            Online OPD booking is available for General Physicians. Browse all doctors below for profiles; specialists are seen via hospital referral or reception.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {groups.map(({ specialty, doctors }) => {
            const { Icon, hint } = specialtyVisual(specialty);
            return (
              <button
                key={specialty}
                type="button"
                onClick={() => onSelectSpecialty(specialty)}
                className="group text-left border border-white/10 bg-white/[0.03] p-5 sm:p-6 hover:border-white/25 hover:bg-white/[0.06] transition"
                data-testid={`specialty-card-${specialty}`}
              >
                <div
                  className="h-11 w-11 flex items-center justify-center mb-4 transition group-hover:scale-105"
                  style={{ background: `${accent}22`, color: accent }}
                >
                  <Icon className="h-5 w-5" />
                </div>
                <p className="font-semibold text-white text-lg leading-tight" style={{ fontFamily: SANS }}>{specialty}</p>
                <p className="text-[13px] mt-1.5 leading-relaxed" style={{ color: IITH.mute }}>{hint}</p>
                <div className="mt-5 flex items-center justify-between gap-2">
                  <span className="inline-flex items-center gap-1.5 text-[11px]" style={{ color: IITH.mute }}>
                    <Users className="h-3.5 w-3.5" />
                    {doctors.length} clinician{doctors.length === 1 ? '' : 's'}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[12px] font-semibold" style={{ color: accent }}>
                    Book OPD <ArrowRight className="h-3.5 w-3.5 group-hover:translate-x-0.5 transition" />
                  </span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
